import { render, staticRenderFns } from "./instrDetail.vue?vue&type=template&id=47f0349f&scoped=true&"
import script from "./instrDetail.vue?vue&type=script&lang=js&"
export * from "./instrDetail.vue?vue&type=script&lang=js&"
import style0 from "./instrDetail.vue?vue&type=style&index=0&id=47f0349f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0349f",
  null
  
)

export default component.exports